import { defineMessages } from 'react-intl';

export default defineMessages({
  plafond: {
    id: 'asi_details.my_contracts.plafond',
  },
  franchise: {
    id: 'asi_details.my_contracts.franchise',
  },
  effectiveDate: {
    id: 'asi_details.my_contracts.effective_date',
  },
  dueDate: {
    id: 'asi_details.my_contracts.due_date',
  },
});
